import { render } from "./ParametrosCheckoutPage.vue?vue&type=template&id=167d4edc"
import script from "./ParametrosCheckoutPage.vue?vue&type=script&lang=js"
export * from "./ParametrosCheckoutPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__